import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import type { Zero } from "@rocicorp/zero";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./query-client";

/** Router context contract; authenticated bootstrap injects `zero` after `ZeroInit` mounts. */
export type RouterContext = {
  zero: Zero | undefined;
};

/** Application router config with viewport preloading and root QueryClient provider wrapper. */
export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultPreload: "viewport",
  defaultPreloadStaleTime: 0,
  defaultPreloadGcTime: 0,
  context: {} as RouterContext,
  Wrap: function WrapComponent({ children }: { children: React.ReactNode }) {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
